module.exports = __webpack_public_path__ + "static/plnu.87cd87e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Affiliations_Section/plnu.jpg
// module id = 444
// module chunks = 35783957827783